import ActivationPackageDefaultEvent from './ActivationPackageDefaultEvent';

const ActivationPackageResubmitted = ({ event }: { event: any }) => {
  return <ActivationPackageDefaultEvent event={event} action="Activation Package Resubmitted" />;
};

export default ActivationPackageResubmitted;
